// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/pages/Login.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/Login.scss';
import { loginUser, fetchCRMSystemInfo, API_URLS } from '../api/api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate(); // ถึงแม้จะใช้ navigate ได้ แต่เราจะเปลี่ยนเป็น window.location
  const [crmSystemInfo, setCrmSystemInfo] = useState(null);

  useEffect(() => {
    const getCRMInfo = async () => {
      try {
        const selectedCRM = await fetchCRMSystemInfo();
        setCrmSystemInfo(selectedCRM);
      } catch (error) {
        console.error('Error fetching CRM system info:', error);
      }
    };

    getCRMInfo();

    // ถ้าพบ token อยู่ใน localStorage (เคยล็อกอินค้างไว้) ให้ไปหน้า Dashboard
    // แต่ในเคสนี้จะยังคงพฤติกรรมเดิม คือถ้าเจอ token แล้ว navigate
    // ถ้าไม่ต้องการ auto-navigate ก็ลบส่วนนี้ออกได้
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/Dashboard');
    }
  }, [navigate]);

  if (!crmSystemInfo) {
    return <div>Loading...</div>;
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // ฟังก์ชันเข้ารหัส UTF-8 รองรับทุกภาษา
  const encodeUTF8 = (value) => btoa(encodeURIComponent(String(value || '')));

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setShowModal(false);

    // ตรวจสอบฟอร์ม
    if (!email || !password) {
      setErrorMessage('Please enter both email and password.');
      setShowModal(true);
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setErrorMessage('Please enter a valid email address.');
      setShowModal(true);
      return;
    }
    if (password.length < 6) {
      setErrorMessage('Password must be at least 6 characters long.');
      setShowModal(true);
      return;
    }

    setIsSubmitting(true);

    try {
      // เรียก API Login
      const data = await loginUser(email, password);

      // ถ้ากรอกผิด
      if (data.message !== 'OK') {
        setErrorMessage('Login failed: Incorrect email or password.');
        setShowModal(true);
        setIsSubmitting(false);
        return;
      }

      // ถ้าสำเร็จ -> เก็บ token, user_ID ใน localStorage
      localStorage.setItem('token', data.token);
      localStorage.setItem('user_ID', data.user);

      const token = localStorage.getItem('token'); 
      const userID = data.user;

      // สร้าง maracarData เริ่มต้น
      let maracarData = [{
        id: 1,
        position: encodeUTF8(''),
        username: encodeUTF8(email.split('@')[0]),
        email: encodeUTF8(email),
        image: '',
        user_ID: encodeUTF8(userID)
      }];

      // ดึงข้อมูลเพิ่มเติม
      try {
        const response = await fetch(API_URLS.SHOW_USER(userID), {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const customerData = await response.json();
          maracarData = [{
            id: 1,
            position: encodeUTF8(customerData.position_ID),
            username: encodeUTF8(customerData.first_name || email.split('@')[0]),
            email: encodeUTF8(customerData.email || email),
            image: customerData.image || '',
            user_ID: encodeUTF8(customerData.user_ID || userID)
          }];

          // ถ้ามี branchID -> เก็บลง localStorage
          const branchID = customerData.branch_ID;
          if (branchID) {
            localStorage.setItem('branch_ID', branchID);
          }
        } else {
          console.warn('Failed to fetch customer details, using default maracarData');
        }
      } catch (error) {
        console.error('Error fetching customer details:', error);
      }

      // เก็บ maracarData ลง localStorage
      localStorage.setItem('maracar', JSON.stringify(maracarData));

      // เมื่อทำงานเสร็จ -> set isSubmitting = false
      setIsSubmitting(false);

      // -----------------------------------------
      // เปลี่ยนคอนเซ็ป: เมื่อ Login เสร็จแล้ว
      // ให้ Refresh หน้าใหม่อีกรอบทันที
      // -----------------------------------------
      // 1) เราไม่ใช้ navigate('/Dashboard') แต่ใช้ window.location
      // 2) ไปเส้นทาง '/Dashboard' เพื่อ Refresh แบบเต็มหน้า (Full Reload)
      window.location.replace('/Dashboard');

    } catch (error) {
      setErrorMessage(error.message || 'An error occurred.');
      setShowModal(true);
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="background-container"
      style={{ backgroundImage: `url(${crmSystemInfo["background-image"]})` }}
    >
      <div className="background-overlay"></div>
      <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
        <div className="card background-login shadow-lg p-4 mb-5 bg-white rounded" style={{ maxWidth: '400px' }}>
          <div className="card-body">
            <h3 className="text-center mb-4">{crmSystemInfo["name-system"]}</h3>

            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label htmlFor="staticEmail" className="form-label">Enter Email</label>
                <input
                  type="email"
                  className="form-control"
                  id="staticEmail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="off"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="inputPassword" className="form-label">Enter Password</label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="inputPassword"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="off"
                  />
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={togglePasswordVisibility}
                  >
                    <i
                      className={
                        showPassword ? "fa-solid fa-eye-slash" : "fa-regular fa-eye"
                      }
                    ></i>
                  </button>
                </div>
              </div>
              <div className="d-grid gap-2">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <i className="fas fa-spinner fa-spin"></i> Logging in...
                    </>
                  ) : (
                    'LOGIN'
                  )}
                </button>
              </div>
            </form>

            <p className="text-center mt-4 footer-text">
              <a href={crmSystemInfo["developer-url"]} target="_blank" rel="noopener noreferrer">
                {crmSystemInfo["developer-info"]}
              </a>
            </p>
          </div>
        </div>

        {showModal && (
          <div className="modal show d-block" tabIndex="-1">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Login Error</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body">
                  <p>{errorMessage}</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showModal && <div className="modal-backdrop show"></div>}
      </div>
    </div>
  );
};

export default Login;
